import { render, staticRenderFns } from "./quickFormItem.vue?vue&type=template&id=29674eac&scoped=true"
import script from "./quickFormItem.vue?vue&type=script&lang=js"
export * from "./quickFormItem.vue?vue&type=script&lang=js"
import style0 from "./quickFormItem.vue?vue&type=style&index=0&id=29674eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29674eac",
  null
  
)

export default component.exports